import { Injectable } from '@angular/core';
import { striptags } from 'striptags';

@Injectable()
export class SanitizerService {

    constructor() { }

    /**
     * Bejövő stringet strippelünk a PHP-hez hasonlóan, csak az engedélyezett elemek mehetnek tovább. 
     * Az &nbsp; jelölésekből szóközt csinálunk.
     * 
     * @param text 
     * @returns 
     */
    static clearText(text: string): string {  

        // TODO az egészet try catchban futtatjuk, mert olyan adat minőség van, hogy simán ráfuthatunk egy text.replace hibára pl.
        try {
            const t = striptags(text.replace('<p>&nbsp;</p>', ''), { allowedTags: new Set(['p', 'br', 'a', 'img']) }).replace('&nbsp;', ' ');                
            return (t.indexOf(':') > -1) ? t.substring(0, t.length - 1) : t;
        } catch (e) {
            return text;
        }    

    }

    /**
     * Az allowed tömbben megadott HTML elemeket átengedjük, a többit strippeljük
     * 
     * @param text 
     * @param allowed 
     * @returns 
     */
    static clearUnallowedText(text: string, allowed: string[]): string {
        const t = striptags(text, { allowedTags: new Set(allowed) }).replace('&nbsp;', ' ');
        return (t.indexOf(':') > -1) ? t.substring(0, t.length - 1) : t;
    }

    /**
     * Minden HTML elemet strippelünk
     * 
     * @param text 
     * @returns 
     */
    static clearHTMLText(text: string): string {
        const t = striptags(text).replace('&nbsp;', ' ');
        return (t.indexOf(':') > -1) ? t.substring(0, t.length - 1) : t;
    }


    static validate = {

        isEmailAddress: (str): boolean => {
            const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            return pattern.test(str);  // returns a boolean
        },
        isNotEmpty: (str): boolean => {
            const pattern = /\S+/;
            return pattern.test(str);  // returns a boolean
        },
        isNumber: (str): boolean => {
            const pattern = /^\d+$/;
            return pattern.test(str);  // returns a boolean
        },
        isSame: (str1, str2): boolean => {
            return str1 === str2;
        },
        onlyNumeric: (event: any): void => {

            const regexpNumber = /[0-9\+\-\ ]/;

            const inputCharacter = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !regexpNumber.test(inputCharacter)) {
                event.preventDefault();
            }

        }


    }

    static clear = {

        phoneNumber: (str): string => {
            try {
                return str.replace(/[^\d]/g, '');
            } catch (e) {
                return '';
            }
        }

    }

    static serializeParam(value: string): string {
        return (value) ? value.replace(/\+/gi, '%2B') : '';
    }

    static serialize(value: string): string {
        return SanitizerService.serializeParam(value);
    }

    static unserialize(value: string): string 
    {
        let ret = (value) ? value.replace(/%2B/gi, '+') : '';
            ret = (ret) ? ret.replace(/%20/gi, '+') : '';

        return ret;
    }

    static nl2br(value: string): string {
        if (value) {
            return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        
        return value;
    }

}
